<template>
  <div>
    <div class="sticky row border-bottom white-bg dashboard-header">
      <div class="col-lg-3">
        <h1>Qualitative Surveys</h1>
      </div>
      <div class="col-lg-6 text-center">
        <div class="filters">
          <el-select placeholder="Filter by" v-model="filterBy" @change="handleFiltersChanged">
            <el-option :key="'survey'" :value="'survey'" :label="'Survey'" />
            <el-option :key="'period'" :value="'period'" :label="'Period'" />
          </el-select>

          <el-select
            placeholder="Select survey"
            filterable
            v-if="filterBy === 'survey'"
            v-model="selectedSurvey"
            :value="selectedSurvey"
            @change="handleFiltersChanged"
          >
            <el-option
              v-for="survey in surveys"
              :key="survey.id"
              :value="survey.id"
              :label="survey.title"
            />
          </el-select>

          <el-select
            placeholder="Select period"
            filterable
            v-model="selectedPeriod"
            v-if="filterBy === 'period'"
            @change="handleFiltersChanged"
          >
            <el-option :key="'month'" :value="'month'" :label="'Monthly'" />
            <el-option :key="'quarter'" :value="'quarter'" :label="'Quarterly'" />
            <el-option :key="'year'" :value="'annual'" :label="'Yearly'" />
            <el-option :key="'lifetime'" :value="'lifetime'" :label="'Lifetime'" />
          </el-select>

          <el-select
            placeholder="Select month"
            filterable
            v-model="selectedPeriodMonth"
            v-if="filterBy === 'period' && selectedPeriod === 'month'"
            @change="handleFiltersChanged"
          >
            <el-option
              v-for="item in periods.month"
              :key="item[0]"
              :value="item[0]"
              :label="item[1]"
            />
          </el-select>

          <el-select
            placeholder="Select quarter"
            filterable
            v-model="selectedPeriodQuarter"
            v-if="filterBy === 'period' && selectedPeriod === 'quarter'"
            @change="handleFiltersChanged"
          >
            <el-option
              v-for="item in periods.quarter"
              :key="item[0]"
              :value="item[0]"
              :label="item[1]"
            />
          </el-select>

          <el-select
            placeholder="Select year"
            filterable
            v-model="selectedPeriodYear"
            v-if="filterBy === 'period' && selectedPeriod === 'annual'"
            @change="handleFiltersChanged"
          >
            <el-option
              v-for="item in periods.annual"
              :key="item[0]"
              :value="item[0]"
              :label="item[1]"
            />
          </el-select>
        </div>
        <div class="total-display">
          <el-radio-group v-model="selectedTotalDisplay" size="mini">
            <el-radio-button label="percentage">Percentage</el-radio-button>
            <el-radio-button label="total">Total</el-radio-button>
            <el-radio-button label="cume">Cume</el-radio-button>
          </el-radio-group>
          <!--
          <el-dropdown trigger="click" @command="handleCommand">
            <el-button type="primary" size="mini">
              Export
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="export">Export current selection</el-dropdown-item>
              <el-dropdown-item command="view_exports">View exported</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          -->
        </div>
      </div>
    </div>

    <div class="row" v-if="!isValidFilter">
      <div class="col-lg-12">
        <div class="empty">No data found, please select your filters.</div>
      </div>
    </div>
    <div class="row" v-if="laodingSurveyAalytics">
      <div class="col-lg-12">
        <loader message="Loading your surveys" />
      </div>
    </div>
    <div
      class="row"
      v-if="isValidFilter && analyticsRowCount === 0 && !loadingCharts && !laodingSurveyAalytics"
    >
      <div class="col-lg-12">
        <empty>Not enough data has been gathered yet to display any results for your filter.</empty>
      </div>
    </div>

    <div class="row" v-if="isValidFilter && analyticsRowCount > 0 && !laodingSurveyAalytics">
      <div class="col-lg-10">
        <h2>{{ currentCategory }}</h2>

        <div class="row" v-for="i in analyticsRowCount" :key="i">
          <div class="col-lg-6" v-for="item in analyticsChartsInRow(i)" :key="item.id">
            <i-box>
              <span slot="title">
                <span class="pull-right text-muted text-right count">
                  <em>n</em>
                  {{ item.respondents }}
                  <br />
                  <span v-if="item.chart !== 'WORDCLOUD'" style="cursor: pointer">
                    [
                    <a @click="handleSetUpOneSheet(item)">One sheet</a>
                    ]
                  </span>
                  <span v-if="item.chart == 'WORDCLOUD'">
                    [
                    <a @click="handleCSVExport(item)">Download</a>
                    ]
                  </span>
                </span>
                <h4>{{ item.question }}</h4>
                <div class="clearfix"></div>
              </span>
              <span slot="content">
                <div class="chart-content">
                  <bar-chart
                    :height="300"
                    :colorCycle="[generateTitleColor(item.question, hueRange)]"
                    :data="totalDisplay(item.answers)"
                    :options="chartOptions"
                    @onClick="handleChartClicked($event, item)"
                    v-if="item.chart.length === 0 || item.chart === 'VERTICAL_BAR'"
                  />
                  <stacked-bar-chart
                    :height="300"
                    :showLegend="true"
                    :legendPosition="'bottom'"
                    :colorCycle="[generateTitleColor(item.question, hueRange)]"
                    :data="stackedTotalDisplay(item.answers)"
                    :options="stackedChartOptions"
                    @onClick="handleChartClicked($event, item)"
                    v-if="item.chart === 'VERTICAL_BAR_STACKED'"
                  />
                  <horizontal-bar-chart
                    :height="300"
                    :colorCycle="[generateTitleColor(item.question, hueRange)]"
                    :data="totalDisplay(item.answers)"
                    :options="chartOptions"
                    @onClick="handleChartClicked($event, item)"
                    v-if="item.chart === 'HORIZONTAL_BAR'"
                  />
                  <pie-chart
                    :height="300"
                    :colorCycle="generateColorPool(totalDisplay(item.answers), hueRange)"
                    :data="totalDisplay(item.answers)"
                    :options="pieChartOptions"
                    @onClick="handleChartClicked($event, item)"
                    v-if="item.chart === 'PIE'"
                  />
                  <donut-chart
                    :height="300"
                    :colorCycle="generateColorPool(totalDisplay(item.answers), hueRange)"
                    :data="totalDisplay(item.answers)"
                    :options="pieChartOptions"
                    @onClick="handleChartClicked($event, item)"
                    v-if="item.chart === 'DONUT'"
                  />
                  <cloud
                    v-if="item.chart == 'WORDCLOUD'"
                    :data="item.answers.words || []"
                    :fontSizeMapper="fontSizeMapper"
                    :width="370"
                    :height="280"
                    :padding="3"
                  />
                </div>
                <div class="legend-content">
                  <chart-legend
                    :colorCycle="[generateTitleColor(item.question, hueRange)]"
                    :data="totalDisplay(item.answers)"
                    :isPercentage="selectedTotalDisplay === 'percentage'"
                    v-if="['HORIZONTAL_BAR', 'VERTICAL_BAR'].includes(item.chart)"
                  />
                  <chart-legend
                    :colorCycle="generateColorPool(totalDisplay(item.answers), hueRange)"
                    :data="totalDisplay(item.answers)"
                    :isPercentage="selectedTotalDisplay === 'percentage'"
                    v-if="['PIE', 'DONUT'].includes(item.chart)"
                  />
                </div>
              </span>
            </i-box>
          </div>
        </div>
        <div class="row" v-if="positiveCategoryProfiles.profiles && !isViewingAllCategories()">
          <div class="col-lg-12">
            <respondent-profile-chart
              title="Only positive respondents"
              :heading="`Demographic of our listenership that shown interest in ${currentCategory}`"
              :profileCharts="positiveCategoryProfiles.profiles"
              :totalRespondents="positiveCategoryProfiles.respondents"
              :selectedTotalDisplay="selectedTotalDisplay"
              :hueRange="colorPieChartSpectrum"
            />
          </div>
        </div>

        <div class="row" v-if="categoryProfiles.profiles">
          <div class="col-lg-12">
            <respondent-profile-chart
              title="All respondents"
              :heading="
                `Demographic of our listenership that completed questions on ${currentCategory}`
              "
              :profileCharts="categoryProfiles.profiles"
              :totalRespondents="categoryProfiles.respondents"
              :selectedTotalDisplay="selectedTotalDisplay"
              :hueRange="respHueRange"
            />
          </div>
        </div>
      </div>

      <div class="categories col-lg-2 sidebar">
        <h3>Categories</h3>
        <el-menu :default-active="selectedCategory" class="survey-analytics-menu">
          <el-menu-item
            index="All"
            :key="'All'"
            :active="currentCategory === 'All'"
            @click="selectedCategory = 'All'"
            >All Categories</el-menu-item
          >
          <el-menu-item
            v-for="category in surveyStats.surveyCategories"
            :index="category"
            :key="category"
            :active="category === currentCategory"
            @click="selectedCategory = category"
            >{{ category }}</el-menu-item
          >
        </el-menu>
      </div>
    </div>

    <!-- <survey-respondents-dialog
      :isVisible="respondentDialogVisible"
      :filtering="respondentFiltering"
      :title="respondentTitle"
      :subtitle="respondentSubtitle"
      @onVisiblityChange="handleRespondentDialogVisibility"
    /> -->
    <survey-export-form-dialog
      :isVisible="exportFormDialogVisible"
      :filterBy="filterBy"
      :surveyId="parseInt(selectedSurvey, 10)"
      :surveyName="surveyName"
      :periodType="selectedPeriod"
      :datetime="new Date(selectedDatetime)"
      @onVisibilityChange="handleExportFormDialogVisibility"
    />
    <survey-export-view-dialog
      :isVisible="exportViewDialogVisible"
      @onVisibilityChange="handleExportViewDialogVisibility"
    />
    <category-one-sheet
      :visible="oneSheetVisible"
      :title="selectedCategory"
      :statData="oneSheetData"
      :selectedTotalDisplay="selectedTotalDisplay"
      @onChangeVisibility="visible => (oneSheetVisible = visible)"
      v-if="oneSheetData && Object.keys(oneSheetData).length > 0"
    />
  </div>
</template>

<script>
import moment from 'moment';
import colorMixin from '@/mixins/colors';

import IBox from '@/components/common/IBox';
import Empty from '@/components/common/Empty';
import BarChart from '@/components/charts/BarChart';
import StackedBarChart from '@/components/charts/StackedBarChart';
import Loader from '@/components/common/Loader';
import HorizontalBarChart from '@/components/charts/HorizontalBarChart';
import PieChart from '@/components/charts/PieChart';
import DonutChart from '@/components/charts/DoughnutChart';
import ChartLegend from '@/components/charts/ChartLegend';
import RespondentProfileChart from '@/components/surveys/RespondentProfileChart';
import CategoryOneSheet from '@/components/surveys/CategoryOneSheet';
import surveyAnalytics from '@/graphql/analytics/surveyAnalytics.gql';
import Cloud from 'vue-d3-cloud';
import { ExportToCsv } from 'export-to-csv';

import { mapState } from 'vuex';

import SurveyRespondentsDialog from '@/components/surveys/SurveyRespondentsDialog';
import SurveyExportFormDialog from '@/components/surveys/SurveyExportFormDialog';
import SurveyExportViewDialog from '@/components/surveys/SurveyExportViewDialog';

import { surveyHueRange, respondentsHueRange } from '@/mixins/colorConstants_live'; // eslint-disable-line

export default {
  name: 'SurveyAnalyticsDashboard',
  components: {
    BarChart,
    CategoryOneSheet,
    ChartLegend,
    DonutChart,
    Loader,
    Empty,
    HorizontalBarChart,
    IBox,
    PieChart,
    RespondentProfileChart,
    StackedBarChart,
    SurveyExportFormDialog,
    SurveyExportViewDialog,
    SurveyRespondentsDialog,
    Cloud,
  },
  mixins: [colorMixin],
  data: () => ({
    analyticsPerRow: 2,
    filterBy: 'period',
    selectedPeriod: 'lifetime',
    selectedPeriodMonth: null,
    selectedPeriodQuarter: null,
    selectedPeriodYear: null,
    selectedSurvey: null,
    selectedCategory: null,
    surveyStats: {},
    hueRange: surveyHueRange,
    respHueRange: respondentsHueRange,
    selectedTotalDisplay: 'percentage',
    respondentDialogVisible: false,
    exportFormDialogVisible: false,
    exportViewDialogVisible: false,
    laodingSurveyAalytics: true,
    respondentFiltering: {},
    respondentTitle: '',
    respondentSubtitle: '',
    oneSheetVisible: false,
    oneSheetData: {},
    periods: [],
    surveys: [],
    colorBarChartSpectrum: [260, 360],
    colorPieChartSpectrum: [160, 260],
    companies: [4, 7, 11, 70],
  }),
  computed: {
    ...mapState('user', ['me']),

    positiveCategoryProfiles() {
      return this.extractProfileCategories(
        this.isViewingAllCategories() ? 'surveyCategoryProfile' : 'surveyCategoryProfilePositive',
      );
    },

    categoryProfiles() {
      return this.extractProfileCategories(
        this.isViewingAllCategories() ? 'surveyProfile' : 'surveyCategoryProfile',
      );
    },

    analyticsCharts() {
      const key = 'surveyAnalytics';
      const qtypes = ['PERMISSION', 'OPT_IN', 'AGE_CONSENT'];
      if (Object.keys(this.surveyStats).indexOf(key) === -1) {
        return [];
      }
      return this.surveyStats[key].filter(c => !c.isProfile && !qtypes.includes(c.question_type));
    },

    categoryAnalyticsCharts() {
      return (
        this.analyticsCharts
          .filter(c => c.category === this.currentCategory || this.isViewingAllCategories())
      );
    },

    analyticsRowCount() {
      return Math.ceil(this.categoryAnalyticsCharts.length / this.analyticsPerRow);
    },

    isValidFilter() {
      if (this.filterBy === 'survey' && this.selectedSurvey !== null) {
        return true;
      }
      return this.filterBy === 'period';
    },

    currentCategory: {
      get() {
        if (
          (!this.selectedCategory && this.surveyStats.surveyCategories.length > 0) ||
          this.surveyStats.surveyCategories.indexOf(this.selectedCategory) < 0
        ) {
          this.selectedCategory = 'All';
        }

        return this.selectedCategory;
      },
    },

    chartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generateTooltipLabel,
          },
        },
      };
    },
    pieChartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generatePieTooltipLabel,
          },
        },
      };
    },
    stackedChartOptions() {
      return {
        tooltips: {
          callbacks: {
            label: this.generateTooltipLabel,
          },
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              barPercentage: 1,
            },
          ],
          yAxes: [
            {
              stacked: true,
            },
          ],
        },
      };
    },
    selectedDatetime() {
      const periodTypeMap = {
        lifetime: null,
        annual: this.selectedPeriodYear,
        quarter: this.selectedPeriodQuarter,
        month: this.selectedPeriodMonth,
      };

      return periodTypeMap[this.selectedPeriod];
    },

    surveyName() {
      const survey = this.surveys.find(s => s.id === this.selectedSurvey);
      if (!survey) {
        return null;
      }
      return survey.title;
    },
  },
  mounted() {
    this.filterBy = this.handleFilterBy();
    this.fetchSurveyAnalytics();
  },
  methods: {
    setSurveys() {
      if (this.surveys.length !== 0) {
        this.selectedSurvey = this.surveys[0].id;
      }
    },

    currentCategory() {
      // Should we set a default category?
      if (
        (!this.selectedCategory && this.surveyStats.surveyCategories.length > 0) ||
        this.surveyStats.surveyCategories.indexOf(this.selectedCategory) < 0
      ) {
        this.selectedCategory = 'All';
      }

      return this.selectedCategory;
    },

    setPeriods() {
      if (this.periods.month !== undefined) {
        this.selectedPeriodMonth = this.periods.month[0][0];
        this.selectedPeriodQuarter = this.periods.quarter[0][0];
        this.selectedPeriodYear = this.periods.annual[0][0];
      }
    },
    selectDatetime() {
      const periodTypeMap = {
        lifetime: moment().format(),
        annual: this.selectedPeriodYear,
        quarter: this.selectedPeriodQuarter,
        month: this.selectedPeriodMonth,
      };

      return periodTypeMap[this.selectedPeriod];
    },
    totalDisplay(answers) {
      return Array.isArray(answers)
        ? answers.map(a => [a.title, a[this.selectedTotalDisplay]])
        : [];
    },
    fetchSurveyAnalytics() {
      this.laodingSurveyAalytics = true;
      this.$apolloProvider.clients.apiv2
        .query({
          query: surveyAnalytics,
          fetchPolicy: 'network-only',
          variables: {
            date: this.selectDatetime(),
            filterBy: this.filterBy,
            period: this.selectedPeriod,
            surveyId: this.getSelectedSurvey(),
          },
        })
        .then(result => {
          this.surveyStats = result.data.surveyAnalytics[0];
          this.periods = this.surveyStats.periods;
          this.surveys = this.surveyStats.surveys;
          this.setPeriods();
          this.currentCategory();
          this.laodingSurveyAalytics = false;
        })
        .catch(error => {
          this.error = error;
          this.laodingSurveyAalytics = false;
        });
    },
    getSelectedSurvey() {
      return this.selectedSurvey !== null ? this.selectedSurvey : 0;
    },
    stackedTotalDisplay(answers) {
      /* eslint-disable-next-line */
      const result = {
        labels: answers.map(a => a.title),
        datasets: answers.map((a, i) => ({
          backgroundColor: this.generateTitleColor(`Ranked # ${i + 1}`),
          label: `Ranked #${i + 1}`,
          data: answers.map(d => {
            if (d[this.selectedTotalDisplay][i] === undefined) return 0;
            return d[this.selectedTotalDisplay][i];
          }),
        })),
      };
      return result;
    },
    isViewingAllCategories() {
      return this.currentCategory === 'All';
    },

    analyticsChartsInRow(index) {
      return this.categoryAnalyticsCharts
        .slice((index - 1) * this.analyticsPerRow, index * this.analyticsPerRow)
        .filter(c => c.category === this.selectedCategory || this.isViewingAllCategories());
    },

    handleFiltersChanged() {
      if (this.filterBy === 'survey' && this.selectedSurvey === null) {
        this.setSurveys();
      }
      if (!this.isValidFilter) {
        return;
      }
      this.fetchSurveyAnalytics();
    },

    fetchSurvey(surveyId) {
      this.$store.dispatch('survey/getSurveyCharts', surveyId);
    },

    fetchPeriod(period, date) {
      this.$store.dispatch('survey/getPeriodCharts', { period, date });
    },

    handleChartClicked(event, questionItem) {
      /* eslint-disable no-underscore-dangle */
      const answer = questionItem.answers[event[1][0]._index];
      this.respondentFiltering = {
        filter_by: this.filterBy,
        period: this.selectedPeriod,
        period_month: this.selectedPeriodMonth,
        period_quarter: this.selectedPeriodQuarter,
        period_year: this.selectedPeriodYear,
        survey_id: questionItem.survey_id,
        choice_id: answer.choice_id,
        question_id: questionItem.question_id,
      };
      this.respondentDialogVisible = true;
      this.respondentTitle = questionItem.question;
      this.respondentSubtitle = answer.title;
    },

    handleProfileClicked(event, title, profileItem) {
      const answer = profileItem[event[1][0]._index];

      this.respondentFiltering = {
        filter_by: this.filterBy,
        period: this.selectedPeriod,
        period_month: this.selectedPeriodMonth,
        period_quarter: this.selectedPeriodQuarter,
        period_year: this.selectedPeriodYear,
        survey_id: this.selectedSurvey,
        choice_id: answer.choice_id,
        category_id: this.categoryProfiles.category_id,
      };
      this.respondentDialogVisible = true;
      this.respondentTitle = title;
      this.respondentSubtitle = answer.title;
    },

    handlePositiveProfileClicked(event, title, profileItem) {
      this.handleProfileClicked(event, title, profileItem);
      this.respondentFiltering = { ...this.respondentFiltering, only_positive: 1 };
    },

    handleGenderClicked(event, title, answer) {
      this.respondentFiltering = {
        filter_by: this.filterBy,
        period: this.selectedPeriod,
        period_month: this.selectedPeriodMonth,
        period_quarter: this.selectedPeriodQuarter,
        period_year: this.selectedPeriodYear,
        survey_id: this.selectedSurvey,
        choice_id: answer.choice_id,
        category_id: this.categoryProfiles.category_id,
      };
      this.respondentDialogVisible = true;
      this.respondentTitle = title;
      this.respondentSubtitle = answer.title;
    },

    handlePositiveGenderClicked(event, title, answer) {
      this.handleGenderClicked(event, title, answer);
      this.respondentFiltering = { ...this.respondentFiltering, only_positive: 1 };
    },

    handleRespondentDialogVisibility(event) {
      this.respondentDialogVisible = event;
    },

    handleExportFormDialogVisibility(event) {
      this.exportFormDialogVisible = event;
    },

    handleExportViewDialogVisibility(event) {
      this.exportViewDialogVisible = event;
    },

    generateTooltipLabel(tooltipItem, data) {
      const label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || '';

      const formatMap = {
        percentage: l => `${l}%`,
        total: l => l.toLocaleString(),
        cume: l => l.toLocaleString(),
      };

      return formatMap[this.selectedTotalDisplay](label);
    },

    generatePieTooltipLabel(tooltipItem, data) {
      const total = this.generateTooltipLabel(tooltipItem, data);
      const label = data.labels[tooltipItem.index];

      return `${label}: ${total}`;
    },

    extractProfileCategories(key) {
      if (Object.keys(this.surveyStats).indexOf(key) < 0 && !this.isViewingAllCategories()) {
        return {};
      }

      const chart = this.isViewingAllCategories()
        ? this.surveyStats[key][0]
        : this.surveyStats[key].filter(c => c.category === this.selectedCategory)[0];
      if (!chart || Object.keys(chart).indexOf('profiles') < 0) {
        return {};
      }

      return chart;
    },

    filterQuestionDemographics(data) {
      // const result = data.filter(s => s.question_id === questionId);
      // console.log(result);
      return this.prepareDemographicData(data);
    },

    prepareDemographicData(demographicData) {
      const profiles = {};
      demographicData.forEach(data => {
        const key = Object.keys(data.profiles)[0];
        const profile = data.profiles[key];
        profiles[key] = profile;
      });
      return profiles;
    },

    assignPositiveKeysToDemographics(data) {
      const replaced = Object.keys(data).map(k => ({ [`${k}_only_positive`]: data[k] }));
      if (replaced.length === 0) {
        return {};
      }
      return replaced.reduce((a, b) => Object.assign({}, a, b));
    },

    handleSetUpOneSheet(questionItem) {
      // const questionId = questionItem.question_id;
      this.oneSheetData = {
        chart: questionItem.chart,
        answers: questionItem.answers,
        words: questionItem.words,
        otherQuestions: this.surveyStats.surveyAnalytics,
        demographics: {
          ...this.filterQuestionDemographics(this.surveyStats.surveyQuestionProfile),
          ...this.assignPositiveKeysToDemographics(
            this.filterQuestionDemographics(
              this.surveyStats.surveyQuestionProfilePositive),
          ),
        },
        insight: questionItem.insight,
      };

      this.oneSheetVisible = true;
    },

    handleCommand(command) {
      const commandMap = {
        export: this.handleExport,
        view_exports: this.handleViewExports,
      };
      commandMap[command]();
    },

    handleExport() {
      this.exportFormDialogVisible = true;
    },

    handleViewExports() {
      this.exportViewDialogVisible = true;
    },
    handleCSVExport(question) {
      const csvExporter = new ExportToCsv({
        headers: [question.question],
        showLabels: true,
        filename: `survey-answers-${moment().format('YYYYMMDDHHmmss')}`,
      });
      csvExporter.generateCsv(question.answers.answers);
    },
    fontSizeMapper: word => Math.log2(word.value) * 20,

    handleFilterBy() {
      return this.companies.includes(this.me.company) ? 'survey' : 'period';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.category-title {
  margin: 25px 0;
}
.survey-analytics-menu {
  background: inherit;
  border-right: none;

  .el-menu-item {
    color: $colony-primary;
    height: 30px;
    line-height: 30px;
  }
  .el-menu-item:hover,
  .el-menu-item:active {
    background-color: $colony-primary;
  }
}

.v-chart-block {
  height: 170px;
  &.bottom {
    margin-top: 20px;
  }
}
.count {
  font-size: 0.9em;
  margin-left: 15px;
}
.total-display {
  margin-top: 5px;
}
.logo-wrapper {
  margin-top: 20px;
}
.chart-content {
  min-height: 300px;
}
div.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  z-index: 99;
}
div.categories {
  width: 15%; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 99; /* Stay on top */
  margin-top: 5; /* Stay at the top */
  right: 0;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// SurveyAnalyticsDashboard.vue?2869627e